import React from 'react'
import * as types from './constants'
import { ErrorsFromApi } from '@myxplor/ui'
import { errorHandler } from '../io/error-handling'
import ErrorDisplayFatal from '../ui/error-display-fatal'

export const sending = () => ({
  type: types.AUTHORISATION_SENDING
})

export const successful = (response) => ({
  type: types.AUTHORISATION_SUCCESSFUL,
  data: response.data
})

export const failed = (payload = {}) => ({
  type: types.AUTHORISATION_FAILED,
  errors: errorHandler({
    errors: payload.errors ? payload.errors : 'Authentication failed',
  }),
})

export const APIFailed = (message = 'Failed to talk to the API') => ({
  type: types.AUTHORISATION_FAILED,
  errors: {
    summary: [
      <ErrorDisplayFatal
        key={0}
        center
        errors={errorHandler({
          errors: message
        })}
      />
    ]
  },
  notification: {
    message: ErrorsFromApi(message),
    message_type: 'error'
  }
})


export const sendUsernamePassword = (params) => (dispatch) => {
  dispatch(sending())

  return fetch(`${process.env.REACT_APP_AUTH_HOST}/api/v1/auth`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(params)
  })
    .then(
      handleResponse(dispatch)
    )
    .catch(response => {
      dispatch(
        APIFailed(response.message)
      )
    })
}

export const sendSessionToken = ({ sessionToken }) => (dispatch) => {
  return fetch(`${process.env.REACT_APP_AUTH_HOST}/api/v1/session`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionToken}`
    }
  })
    .then(
      handleResponse(dispatch)
    )
    .catch(response => {
      dispatch(
        APIFailed(response.message)
      )
    })
}

const handleResponse = dispatch => response =>
  response.json().then(payload => {
    dispatch(response.ok ? successful(payload) : failed(payload))
  })



// WEBPACK FOOTER //
// ./src/authorisation/actions.js